
export default function GlobeWithPin({
  fill = 'black',
  size = 24,
  className,
}: {
  fill?: string;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 1.91667C12.9529 1.91667 13.8764 2.04912 14.7522 2.29709C15.313 2.0524 15.9323 1.91667 16.5833 1.91667C19.1146 1.91667 21.1667 3.9687 21.1667 6.50001C21.1667 6.85802 21.1219 7.20167 21.0416 7.53184C21.7087 8.87943 22.0833 10.3971 22.0833 12C22.0833 17.5689 17.5689 22.0833 12 22.0833C6.43113 22.0833 1.91667 17.5689 1.91667 12C1.91667 11.6169 1.93803 11.2388 1.97963 10.8668C1.98063 10.8564 1.98181 10.846 1.98316 10.8357C2.5604 5.81525 6.82492 1.91667 12 1.91667ZM4.0104 9.9356C4.9269 6.37829 8.15652 3.75001 12 3.75001C12.2981 3.75001 12.5923 3.76578 12.8819 3.79651C12.3274 4.55441 12 5.48898 12 6.50001C12 7.80315 12.5929 8.91603 13.3362 9.88121C13.9546 10.6841 14.746 11.4684 15.5097 12.2253C15.6529 12.3673 15.7952 12.5082 15.9352 12.6482C16.2931 13.0062 16.8735 13.0062 17.2315 12.6482C17.3715 12.5082 17.5137 12.3673 17.6569 12.2253C18.4207 11.4684 19.2121 10.6841 19.8304 9.88121C19.8663 9.83462 19.9018 9.78767 19.937 9.74039C20.1408 10.458 20.25 11.2158 20.25 12C20.25 16.5564 16.5564 20.25 12 20.25C11.8462 20.25 11.6934 20.2458 11.5418 20.2375L11.5418 19.2139L13.7101 16.6842C14.2719 16.0287 14.0978 15.0238 13.3483 14.5955L10.8388 13.1614L9.19408 10.2792C8.9276 9.81226 8.41339 9.54344 7.87785 9.59114L4.0104 9.9356ZM16.5833 5.12501C15.9505 5.12501 15.4375 5.63801 15.4375 6.27084C15.4375 6.90366 15.9505 7.41667 16.5833 7.41667C17.2162 7.41667 17.7292 6.90366 17.7292 6.27084C17.7292 5.63801 17.2162 5.12501 16.5833 5.12501Z"
        fill={fill}
      />
    </svg>
  );
}
